module.exports = __webpack_public_path__ + "media/images/countryrect/gs-244ec97921f7b21ca44238f87b7f2d28.svg";